import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 企业基础信息
  getEnterpriseKeyData: `${baseUrl}/enterprise/data/image/getKeyData`,

  // 企业工商信息
  getEnterpriseBusinessData: `${baseUrl}/enterprise/data/image/getBusinessData`,

  // 企业质量
  getEnterpriseRadarData: `${baseUrl}/enterprise/data/image/getRadarData`,

  // 学历分布
  getEnterpriseEducationData: `${baseUrl}/enterprise/data/image/getEducationData`,

  // 知识产权
  getEnterpriseIntellectualPropertyData: `${baseUrl}/enterprise/data/image/getIntellectualPropertyData`,

  // 产值分析
  getEnterpriseOutputData: `${baseUrl}/enterprise/data/image/getOutputData`,

  // 税收分析
  getEnterpriseTaxData: `${baseUrl}/enterprise/data/image/getTaxData`,

  // 人员活跃度
  getEnterpriseActivityData: `${baseUrl}/enterprise/data/image/getActivityData`,

  // 能耗趋势
  getEnterpriseEnergyUseData: `${baseUrl}/enterprise/data/image/getEnergyUseData`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/PortraitOfEnterpriseInfo.js